export const CREATE_LOBBY = "CREATE_LOBBY";
export const UPDATE_LOBBY = "UPDATE_LOBBY";
export const DELETE_LOBBY = "DELETE_LOBBY";
export const LISTEN_TO_SELECTED_LOBBY = "LISTEN_TO_SELECTED_LOBBY";
export const CLEAR_SELECTED_LOBBY = "CLEAR_SELECTED_LOBBY";
